export const organisationConstants = {
  GETALL_REQUEST: 'ORGANISATIONS_GETALL_REQUEST',
  GETALL_SUCCESS: 'ORGANISATIONS_GETALL_SUCCESS',
  GETALL_FAILURE: 'ORGANISATIONS_GETALL_FAILURE',
  GETFILTER_REQUEST: 'ORGANISATIONS_GETFILTER_REQUEST',
  GETFILTER_SUCCESS: 'ORGANISATIONS_GETFILTER_SUCCESS',
  GETFILTER_FAILURE: 'ORGANISATIONS_GETFILTER_FAILURE',
};